
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/reset-password",
      function () {
        return require("private-next-pages/company/reset-password/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/reset-password"])
      });
    }
  